//
//
//

export type GpPaymentMethod = string;
export type GpSessionId = string;

//
//
//
export enum PaymentType {
  Osbal = 'osbal',
  Osdebt = 'osdebt',
  Renewal = 'renew',
  LiveChat = 'livechat',
}

export interface PaymentRequestDetails {
  amount: number;
  paymentType: PaymentType;
  fields:
    | RenewalPaymentFields
    | OsbalPaymentFields
    | OsdebtPaymentFields
    | LiveChatPaymentFields;
}

//
// Payment type fields.
//

export interface BasePaymentFields {
  ref: string;
  email: string;
  name: string;
}

export interface RenewalPaymentFields extends BasePaymentFields {
  insurer: string;
  terms: string;
  renewdate: string;
  invitedate: string;
  tier: string;
}

export interface OsbalPaymentFields extends BasePaymentFields {
  product: string;
  terms: string;
  vuln: boolean;
  createdate: string;
}

export interface OsdebtPaymentFields extends BasePaymentFields {
  product: string;
  terms: string;
  paid: boolean;
  createdate: string;
  expiredate: string;
}

export interface LiveChatPaymentFields extends BasePaymentFields {
  product: string;
  created_at: string;
}
